export const ACCOUNTS_CHANGE_STATUS_OPEN_MODAL = "ACCOUNTS_CHANGE_STATUS_OPEN_MODAL";
export const ACCOUNTS_CHANGE_STATUS_CLOSE_MODAL = "ACCOUNTS_CHANGE_STATUS_CLOSE_MODAL";

export const ACCOUNTS_CHANGE_STATUS_REQUEST = "ACCOUNTS_CHANGE_STATUS_REQUEST";
export const ACCOUNTS_CHANGE_STATUS_RESULT = "ACCOUNTS_CHANGE_STATUS_RESULT";

export const ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST = "ACCOUNTS_CHANGE_STATUS_REQUEST_REQUEST";
export const ACCOUNTS_CHANGE_STATUS_REQUEST_RESULT = "ACCOUNTS_CHANGE_STATUS_REQUEST_RESULT";